// client/utils/bootstrap-auth.js
import { cookieUtils } from "./utils/cookie-parser";

export async function bootstrapAuth() {
  try {
    const jwt = cookieUtils.getCookie("auth_token");
    if (!jwt) return; // nothing to do

    const auth = cookieUtils.getObjectCookie("auth");
    const hasNames =
      !!auth &&
      (!!auth.first_name ||
        !!auth.last_name ||
        !!auth.user_type ||
        !!auth.email);

    if (hasNames) return; // already hydrated

    // Pull fresh user from server and populate cookie + LS
    const res = await fetch("/session", { credentials: "include" });
    if (!res.ok) return;

    const data = await res.json();
    const u = data && data.user;
    if (!u) return;

    const minimal = {
      token: jwt,
      user_id: u.user_id,
      user_type: u.user_type || u.userType || "",
      email: u.email || "",
      first_name: u.first_name || "",
      last_name: u.last_name || "",
      parent_email: u.parent_email || "",
      parent_email2: u.parent_email2 || "",
    };

    cookieUtils.setCookie("auth", JSON.stringify(minimal), 200);

    try {
      localStorage.setItem("auth", "1");
      localStorage.setItem("token", jwt);
      localStorage.setItem("user", JSON.stringify(u));
      localStorage.setItem("userData", JSON.stringify(u));
      localStorage.setItem("first_name", minimal.first_name);
      localStorage.setItem("last_name", minimal.last_name);
      localStorage.setItem("user_type", minimal.user_type);
    } catch {}
  } catch {
    // ignore
  }
}
